const IMG = (hash) => `https://static.prod-images.emergentagent.com/jobs/34d0fe30-a679-46a0-ac9d-8d3b61a5f41d/images/${hash}`;

export const f3dHeroImage = 'https://customer-assets-lqy194kg.emergentagent.net/job_fantasti100-landing/artifacts/a158c81c85d53362_image.png';

export const f3dTeaser = {
  eyebrow: 'FANTASTI3D',
  title: ['Diamo forma', 'alle idee.'],
  subtitle: 'Stampa 3D di grande formato per mascheroni, decorazioni e allestimenti.',
  text: 'Dal progetto digitale alla realizzazione finale: trasformiamo idee e scenografie in elementi reali grazie alla stampa 3D.',
  cta: 'SCOPRI FANTASTI3D',
};

export const f3dHero = {
  label: 'FANTASTI3D',
  titleA: 'Fantasti',
  titleB: '3D',
  subtitle: 'STAMPA 3D SU COMMISSIONE',
  headline: 'Dalla stampa 3D ai mascheroni.',
  text: 'Realizziamo mascheroni, decorazioni e allestimenti su commissione con la stampa 3D di grande formato. Diamo forma alle tue idee, per il Carnevale e non solo.',
  cta: 'CONTATTACI',
};

export const f3dRealizzazioni = [
  { id: 'mascheroni', label: 'MASCHERONI', image: IMG('c35c9fe94f6eedc4772c14b5e720013ad2dca523b4aa00bd1f64ab9d7cea0485.jpeg'), text: 'Volti, figure e personaggi di grandi dimensioni realizzati su misura.' },
  { id: 'decorazioni', label: 'DECORAZIONI', image: IMG('6951c763a69db72e874f33e382cfa2b9da03e0985fd1f69991cb4430d84ada4f.jpeg'), text: 'Elementi scenografici e decorativi personalizzati, dal singolo dettaglio alle grandi strutture.' },
  { id: 'allestimenti', label: 'ALLESTIMENTI PER VETRINE', image: IMG('b042a5eed4f8585a276bd7c34af0f2a8ccb44e933bb64a2a43f77ceed1133745.jpeg'), text: 'Scenografie e allestimenti personalizzati per vetrine, eventi e spazi commerciali.' },
];

export const f3dProcess = [
  { n: '01', title: 'IDEA', text: 'Raccontaci il tuo progetto.', image: IMG('5fb551d34bbb02b56bd601984986e3edc089bbb4111a6c4f05eaa791c46419d6.jpeg') },
  { n: '02', title: 'MODELLAZIONE', text: 'Progettazione e ottimizzazione in 3D.', image: IMG('005cbf43870903c449da131047a60b44bd0bf40c7b7aaf979af9ced1f7bf30c0.jpeg') },
  { n: '03', title: 'STAMPA 3D', text: 'Produzione in sezioni di grande formato.', image: IMG('e69cbe7296d89aa4deeb5339e51b299808ea031dade8cea91d29666e532de76f.jpeg') },
  { n: '04', title: 'ASSEMBLAGGIO E FINITURA', text: 'Unione delle parti, rivestimento in cartapesta e verniciatura.', image: IMG('c240bda246e9f9e1ddeb9592817369390fc499fcbc959d9d9ce09600e896f6b0.jpeg') },
];

export const f3dFinal = {
  titleA: 'Hai un’idea?',
  titleB: 'Realizziamola insieme.',
  text: 'Che si tratti di un mascherone, di una decorazione o di un allestimento su misura, contattaci per raccontarci il tuo progetto. Studieremo insieme la soluzione più adatta.',
  cta: 'CONTATTACI',
};
